module.exports = __webpack_public_path__ + "static/fifth_user_image1-26a4147b2caf9508cd3c42815d00fcdd.jpg";